import React from 'react'
import { Link } from 'react-router-dom'
import { modes } from 'utils/redux/config/modes'
import Heading from 'components/Heading'
import CalculatorContainer from 'containers/CalculatorContainer'
import FeaturedCurrencyCardsContainer from 'containers/FeaturedCurrencyCardsContainer'
import FeaturedCryptoCurrencyCardsContainer from 'containers/FeaturedCryptoCurrencyCardsContainer'
import PropTypes from 'prop-types'
import Ad from 'components/Ad'

export const Header = props => {
	const { selectedMode = 'monetary', currencyParam, isHome, showModeBtn, showCalculator, showFeatured, title} = props
	const modeSettings = modes[selectedMode]
	return <div className={`c-header c-header--${modeSettings.color} u-text--white ${!showFeatured ? 'u-margin-bottom-none' : ''}`}>
		<div className='o-wrapper'>
			<div className='o-grid o-grid--middle o-layout u-padding-vertical'>
				<div className='o-layout__item u-1/1 u-1/3@tablet u-center-on-mobile u-margin-bottom u-margin-bottom-none@desktop'>
					<Link to={'/'}>
						<img src='/img/logo.svg' alt='Rates.bg Logo'/>
					</Link>
				</div>
				<div className='o-layout__item u-1/1 u-1/3@tablet u-center-on-mobile u-margin-bottom u-margin-bottom-none@desktop'>
					{/*AdSense*/}
					<Ad
						slot='1177920927'
						style={{ display: 'block', height: 50 }}
					/>
				</div>
				{
					showModeBtn &&
						<div className='o-layout__item u-1/1 u-1/3@tablet o-layout--right u-center-on-mobile'>
							<Link to={modeSettings.switchBtnLink}><span className={`c-btn c-btn--${modeSettings.oppositeColor}`}>Към {modeSettings.switchBtnLabel}</span></Link>
						</div>
				}
			</div>
			<div className='u-border-bottom--white-50 u-show-on-desktop'/>
			<div className='o-layout'>
				<div className='o-layout__item u-1/1'>
					<Heading
						priority={1}
						text={title}
						classes={`u-margin-vertical u-margin-top-huge@tablet u-margin-bottom-large@tablet u-heading-line u-heading-line-${modeSettings.oppositeColor} ${isHome ? 'u-show-on-desktop' : ''}`} />
					{ showCalculator && <CalculatorContainer currencyParam={currencyParam} {...props} /> }
				</div>
				{ showFeatured &&
					<div className='o-layout__item u-1/1'>
						{
							selectedMode === 'monetary' &&
							<FeaturedCurrencyCardsContainer {...props} />
						}
						{
							selectedMode === 'crypto' &&
							<FeaturedCryptoCurrencyCardsContainer {...props} />
						}
					</div>
				}
			</div>
		</div>
	</div>
}

Header.propTypes = {
	selectedMode: PropTypes.string,
	currencyParam: PropTypes.string,
	isHome: PropTypes.bool,
	showModeBtn: PropTypes.bool,
	showCalculator: PropTypes.bool,
	showFeatured: PropTypes.bool,
	title: PropTypes.string
}

export default Header
